<template>
  <Component
    :is="isButton ? 'button' : 'div'"
    type="button"
    class="transition-all"
    :class="hideGradient ? hiddenGradientClass : gradientClass"
    :style="borderStyle"
  >
    <div class="h-full w-full"
         :style="innerBorderStyle"
         :class="[innerBorderClasses, innerBorderBg]">
      <slot/>
    </div>
  </Component>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  borderRadius: {type: Number, default: 0},
  borderWidth: {type: Number, default: 0.125},
  borderTopLeftRadius: {type: Number, default: null},
  borderTopRightRadius: {type: Number, default: null},
  borderBottomLeftRadius: {type: Number, default: null},
  borderBottomRightRadius: {type: Number, default: null},
  borderTopWidth: {type: Number, default: 0.125},
  borderRightWidth: {type: Number, default: 0.125},
  borderBottomWidth: {type: Number, default: 0.125},
  borderLeftWidth: {type: Number, default: 0.125},
  gradientClass: {type: String, default: "bg-gradient"},
  hideGradient: {type: Boolean, default: false},
  hiddenGradientClass: {type: String, default: "bg-white"},
  innerBorderBg: {type: String, default: "bg-white"},
  innerBorderStyles: {type: String, default: ""},
  innerBorderClasses: {type: String, default: "bg-opacity-80"},
  isButton: {type: Boolean, default: false},
});

const borderStyle = computed(() => {
  const borderTopLeftRadius = props.borderTopLeftRadius ?? props.borderRadius;
  const borderTopRightRadius = props.borderTopRightRadius ?? props.borderRadius;
  const borderBottomLeftRadius = props.borderBottomLeftRadius ?? props.borderRadius;
  const borderBottomRightRadius = props.borderBottomRightRadius ?? props.borderRadius;

  const paddingTop = props.borderWidth ?? props.borderTopWidth;
  const paddingRight = props.borderWidth ?? props.borderRightWidth;
  const paddingBottom = props.borderWidth ?? props.borderBottomWidth;
  const paddingLeft = props.borderWidth ?? props.borderLeftWidth;

  return `border-top-left-radius: ${borderTopLeftRadius}rem;
          border-top-right-radius: ${borderTopRightRadius}rem;
          border-bottom-left-radius: ${borderBottomLeftRadius}rem;
          border-bottom-right-radius: ${borderBottomRightRadius}rem;
          padding-top: ${paddingTop}rem;
          padding-right: ${paddingRight}rem;
          padding-bottom: ${paddingBottom}rem;
          padding-left: ${paddingLeft}rem;`;
});

const innerBorderStyle = computed(() => {
  const borderTopLeftRadius = (props.borderTopLeftRadius ?? props.borderRadius) - (props.borderWidth ?? props.borderTopWidth);
  const borderTopRightRadius = (props.borderTopRightRadius ?? props.borderRadius) - (props.borderWidth ?? props.borderLeftWidth);
  const borderBottomLeftRadius = (props.borderBottomLeftRadius ?? props.borderRadius) - (props.borderWidth ?? props.borderBottomWidth);
  const borderBottomRightRadius = (props.borderBottomRightRadius ?? props.borderRadius) - (props.borderWidth ?? props.borderRightWidth);

  return `border-top-left-radius: ${borderTopLeftRadius}rem;
          border-top-right-radius: ${borderTopRightRadius}rem;
          border-bottom-left-radius: ${borderBottomLeftRadius}rem;
          border-bottom-right-radius: ${borderBottomRightRadius}rem;
          ${props.innerBorderStyles}`;
});
</script>
